export const orderIntakeFeatureToggles = {
  enableSlotManagementForRmcOrderIntake: 'enableSlotManagementForRmcOrderIntake',
  enableConfirmationPin: 'enableConfirmationPin',
  enableOrderIntakeContractSelection: 'enableOrderIntakeContractSelection'
} as const

export type OrderIntakeFeatureToggleNames = keyof typeof orderIntakeFeatureToggles

export type OrderIntakeFeatureToggles = {
  [K in OrderIntakeFeatureToggleNames]: boolean
}
